import React from 'react'
import { useTranslation } from 'next-i18next'
import { Typography } from 'antd'
import { CustomModal } from 'src/components'
const { Title } = Typography


const CompanyVatErrorModal = ({ isModalVisible, handleCancel, countryName, vatNumber }) => {
  const { t } = useTranslation()

  return (
    <>
      <CustomModal
        title={t('settings.VatErrorTittle')}
        footer={null}
        open={isModalVisible}
        onCancel={handleCancel}
      >
        <Title level={5} type='secondary'>
          {t('settings.VatErrorContent', { vatNumber, countryName })}
        </Title>
      </CustomModal>
    </>
  )
}
export default CompanyVatErrorModal
